
import { defineComponent } from "vue";

export default defineComponent({
    name: "LinkageChangeEmailRescueProfileConfirm",
    setup() {
        return {
        };
    }
});
